import { useState } from "react";
import { resetPassword } from '../services/api';
import { useSearchParams, useNavigate } from "react-router-dom";


const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get('token');
  const email = searchParams.get('email');

  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!token || !email) {
      setError('Invalid or expired reset link.');
      return;
    }

    if (password !== passwordConfirmation) {
      setError('Passwords do not match.');
      return;
    }

    try {
      setLoading(true);

      const res = await resetPassword({
        token,
        email,
        password,
        password_confirmation: passwordConfirmation,
      });

      setMessage(res.message || 'Password reset successful');

      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err) {
      setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-xxl-4 col-xl-5 col-md-6 d-md-block d-none ps-0">
          <div className="login-image">
            <div className="login-logo">
              <h4 className="text-white">Logo</h4>
            </div>
            <div className="login-content">
              <h3 className="text-white head-xs font-600">“Sending money worldwide is now instant, secure, and effortless.”</h3>
              <p className="text-white text-sm font-400 pt-2">Send, receive, and relax — your money’s already there.</p>
            </div>
          </div>
        </div>
        <div className="col-xxl-8 col-xl-7 col-md-6">
          <div className="row vh-100 align-items-center justify-content-center">
            <div className="col-xxl-6 col-xl-10">
              <div className="p-4">
                <div className="text-center pb-4">
                  <h3 className="theme-text-black head-sm font-600 pb-2">Forgot Your Password?</h3>
                  <p className="theme-text-color text-sm font-500 pb-2">Securely reset your password and regain access to your account.</p>
                </div>
                <div className="">
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label">New Password</label>
                      <input
                        type="password"
                        placeholder="Enter your New Password"
                        value={password}
                        className="form-control"
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
                    <div className="mb-5">
                      <label className="form-label">Confirm Password</label>
                      <input
                        type="password"
                        placeholder="Enter your Confirm Password"
                        value={passwordConfirmation}
                        className="form-control"
                        onChange={(e) => setPasswordConfirmation(e.target.value)}
                      />
                    </div>
                    <button type="submit" className="theme-btn justify-content-center w-100" disabled={loading}>
                      {loading ? 'Resetting...' : 'Forgot Password'}
                    </button>

                    {error && <p style={{ color: 'red' }}>{error}</p>}
                    {message && <p style={{ color: 'green' }}>{message}</p>}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
